<template>
  <el-dialog
    title="修改房源信息"
    :visible.sync="dialogVisible"
    width="90%"
    :close-on-click-modal="false"
    @close="handleClose"
    class="update-house-dialog"
    top="3vh"
  >
    <div class="dialog-content-wrapper">
      <!-- 原生滚动区域 -->
      <div class="scroll-area-native">
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="auto"
          size="small"
          class="update-form"
        >
          <!-- ====== 基础信息 ====== -->
          <div class="form-section">
            <div class="section-title">基础信息</div>
            <el-row :gutter="20">
              <!-- 第1行：房屋地址（占2列，不可编辑） -->
              <el-col :span="24">
                <el-form-item label="房屋地址" prop="房屋地址">
                  <el-input v-model="formData.房屋地址" disabled placeholder="请输入房屋地址" />
                </el-form-item>
              </el-col>
              
              <!-- 第2行：产权证地址（占2列，不可编辑） -->
              <!-- <el-col :span="24">
                <el-form-item label="产权证地址" prop="产权证地址">
                  <el-input v-model="formData.产权证地址" disabled placeholder="请输入产权证地址" />
                </el-form-item>
              </el-col> -->
              
              <!-- 第3行：不动产权号 + 丘权号 -->
              <el-col :span="12">
                <el-form-item label="不动产权号" prop="不动产权号">
                  <el-input v-model="formData.不动产权号" placeholder="请输入不动产权号" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="丘权号" prop="丘权号">
                  <el-input v-model="formData.丘权号" placeholder="请输入丘权号" />
                </el-form-item>
              </el-col>
              
              <!-- 第4行：行政区+业务状态 -->
              <el-col :span="12">
              <el-form-item label="行政区" prop="行政区">
                <el-select v-model="formData.行政区" placeholder="请选择行政区" clearable style="width:100%">
                  <el-option label="青秀区" value="青秀区" />
                  <el-option label="兴宁区" value="兴宁区" />
                  <el-option label="江南区" value="江南区" />
                  <el-option label="良庆区" value="良庆区" />
                  <el-option label="邕宁区" value="邕宁区" />
                  <el-option label="西乡塘区" value="西乡塘区" />
                  <el-option label="武鸣区" value="武鸣区" />
                  <el-option label="横州市" value="横州市" />
                  <el-option label="宾阳县" value="宾阳县" />
                  <el-option label="上林县" value="上林县" />
                  <el-option label="马山县" value="马山县" />
                  <el-option label="隆安县" value="隆安县" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务状态" prop="业务状态">
                <el-select v-model="formData.业务状态" placeholder="请选择业务状态" style="width:100%">
                  <el-option label="待出租" value="待出租" />
                  <el-option label="已出租" value="已出租" />
                  <el-option label="已到期" value="已到期" />
                  <el-option label="已中止" value="已中止" />
                  <el-option label="装修中" value="装修中" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
            </el-col>
                          
              <!-- 第5行：出房指导价 + 收房指导价 -->
              <el-col :span="12">
                <el-form-item label="出房指导价" prop="出房指导价">
                  <el-input-number
                    v-model="formData.出房指导价"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入出房指导价"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收房指导价" prop="收房指导价">
                  <el-input-number
                    v-model="formData.收房指导价"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入收房指导价"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              
              <!-- 第6行：收房人 + 收房门店 -->
              <el-col :span="12">
                <el-form-item label="收房人" prop="收房人">
                  <el-input v-model="formData.收房人" placeholder="请输入收房人" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收房门店" prop="收房门店">
                  <el-input v-model="formData.收房门店" placeholder="请输入收房门店" />
                </el-form-item>
              </el-col>
              
              <!-- 第7行：室 + 厅 + 卫 + 面积（平米） -->
              <el-col :span="6">
                <el-form-item label="室" prop="室">
                  <el-input-number
                    v-model="formData.室"
                    :min="0"
                    :max="99"
                    :step="1"
                    placeholder="室"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="厅" prop="厅">
                  <el-input-number
                    v-model="formData.厅"
                    :min="0"
                    :max="99"
                    :step="1"
                    placeholder="厅"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="卫" prop="卫">
                  <el-input-number
                    v-model="formData.卫"
                    :min="0"
                    :max="99"
                    :step="1"
                    placeholder="卫"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="面积（平米）" prop="面积（平米）">
                  <el-input-number
                    v-model="formData['面积（平米）']"
                    :min="0"
                    :precision="2"
                    :step="1"
                    placeholder="面积"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              
              <!-- 第8行：楼层信息（第X层 + 共X层）+ 用途 + 朝向 -->
              <el-col :span="6">
                <el-form-item label="第X层" prop="楼层信息_第X层">
                  <el-input-number
                    v-model="formData.楼层信息_第X层"
                    :min="1"
                    :max="99"
                    :step="1"
                    placeholder="第X层"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="共X层" prop="楼层信息_共X层">
                  <el-input-number
                    v-model="formData.楼层信息_共X层"
                    :min="1"
                    :max="99"
                    :step="1"
                    placeholder="共X层"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用途" prop="用途">
                  <el-select v-model="formData.用途" placeholder="请选择用途" style="width:100%">
                    <el-option label="住宅" value="住宅" />
                    <el-option label="公寓" value="公寓" />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="朝向" prop="朝向">
                  <el-select v-model="formData.朝向" placeholder="请选择朝向" style="width:100%">
                    <el-option label="东" value="东" />
                    <el-option label="南" value="南" />
                    <el-option label="西" value="西" />
                    <el-option label="北" value="北" />
                    <el-option label="东南" value="东南" />
                    <el-option label="东北" value="东北" />
                    <el-option label="西南" value="西南" />
                    <el-option label="西北" value="西北" />
                    <el-option label="东西" value="东西" />
                    <el-option label="南北" value="南北" />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </el-form-item>
              </el-col>
              
              <!-- 第9行：水卡 + 电卡用户名 + 电卡 + 气卡 -->
              <el-col :span="6">
                <el-form-item label="水卡" prop="水卡">
                  <el-input v-model="formData.水卡" placeholder="请输入水卡" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="气卡" prop="气卡">
                  <el-input v-model="formData.气卡" placeholder="请输入气卡" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="电卡" prop="电卡">
                  <el-input v-model="formData.电卡" placeholder="请输入电卡" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="电卡用户名" prop="电卡用户名">
                  <el-input v-model="formData.电卡用户名" placeholder="请输入电卡用户名" />
                </el-form-item>
              </el-col>
              
              <!-- 第10行：其他卡（占2列）+ 钥匙/密码（占2列） -->
              <el-col :span="12">
                <el-form-item label="其他卡" prop="其他卡">
                  <el-input v-model="formData.其他卡" placeholder="请输入其他卡" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="钥匙/密码" prop="钥匙/密码">
                  <el-input v-model="formData['钥匙/密码']" placeholder="请输入钥匙/密码" />
                </el-form-item>
              </el-col>
              
              <!-- 第11行：备注（占2列） -->
              <el-col :span="24">
                <el-form-item label="备注" prop="备注">
                  <el-input v-model="formData.备注" type="textarea" :rows="2" placeholder="请输入备注" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- ====== 收房详情 ====== -->
          <div class="form-section">
            <div class="section-title">收房详情</div>
            
            <!-- 第1行：产权人 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="产权人" prop="房东姓名">
                  <el-input v-model="formData.房东姓名" placeholder="请输入产权人" />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第2行：产权人电话 + 产权人身份证号 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="产权人电话" prop="房东电话">
                  <el-input v-model="formData.房东电话" placeholder="请输入产权人电话" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="产权人身份证号" prop="产权人身份证号">
                  <el-input v-model="formData.产权人身份证号" placeholder="请输入产权人身份证号" />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第3行：受托代理人姓名 + 委托人电话 + 送达地址 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="受托代理人姓名" prop="受托代理人姓名">
                  <el-input v-model="formData.受托代理人姓名" placeholder="请输入受托代理人姓名" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="委托人电话" prop="委托人电话">
                  <el-input v-model="formData.委托人电话" placeholder="请输入委托人电话" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="送达地址" prop="送达地址">
                  <el-input v-model="formData.送达地址" placeholder="请输入送达地址" />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第4行：收房渠道 + 收房费用 + 合同编号 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="收房渠道" prop="收房渠道">
                <el-select v-model="formData.收房渠道" placeholder="请选择收房渠道" style="width:100%">
                  <el-option label="中介" value="中介" />
                  <el-option label="外网" value="外网" />
                  <el-option label="老客户介绍" value="老客户介绍" />
                  <el-option label="续签" value="续签" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收房费用" prop="收房费用">
                <el-input-number
                  v-model="formData.收房费用"
                  :min="0"
                  :precision="2"
                  :step="100"
                  placeholder="请输入收房费用"
                  controls-position="right"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合同编号" prop="合同编号">
                <el-input v-model="formData.合同编号" placeholder="请输入合同编号" />
              </el-form-item>
            </el-col>
          </el-row>
            <!-- 第5行：合同起始日 + 合同到期日 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="合同起始日" prop="合同起始日">
                  <el-date-picker
                    v-model="formData.合同起始日"
                    type="date"
                    placeholder="请选择合同起始日"
                    value-format="timestamp"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同到期日" prop="合同到期日">
                  <el-date-picker
                    v-model="formData.合同到期日"
                    type="date"
                    placeholder="请选择合同到期日"
                    value-format="timestamp"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第6行：三个免租期 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="第一年免租期（天）" prop="第一年免租期（天）">
                  <el-input-number
                    v-model="formData['第一年免租期（天）']"
                    :min="0"
                    :max="365"
                    :step="1"
                    placeholder="天数"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="第二年免租期（天）" prop="第二年免租期（天）">
                  <el-input-number
                    v-model="formData['第二年免租期（天）']"
                    :min="0"
                    :max="365"
                    :step="1"
                    placeholder="天数"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="第三年免租期（天）" prop="第三年免租期（天）">
                  <el-input-number
                    v-model="formData['第三年免租期（天）']"
                    :min="0"
                    :max="365"
                    :step="1"
                    placeholder="天数"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第7行：免租期备注 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="免租期备注" prop="免租期备注">
                  <el-input v-model="formData.免租期备注" placeholder="请输入免租期备注" />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第8行：押金 + 收房租金（元/月） + 支付周期 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="押金" prop="押金">
                  <el-input-number
                    v-model="formData.押金"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入押金"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收房租金（元/月）" prop="收房租金（元/月）">
                  <el-input-number
                    v-model="formData['收房租金（元/月）']"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入收房租金"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="支付周期" prop="支付周期">
                  <el-select v-model="formData.支付周期" placeholder="请选择支付周期" style="width:100%">
                    <el-option label="按月" value="按月" />
                    <el-option label="按季" value="按季" />
                    <el-option label="按半年" value="按半年" />
                    <el-option label="按年" value="按年" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第9行：特别约定 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="特别约定" prop="特别约定">
                  <el-input v-model="formData.特别约定" type="textarea" :rows="2" placeholder="请输入特别约定" />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第10行：支付户名 + 银行卡号 + 开户行 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="支付户名" prop="支付户名">
                  <el-input v-model="formData.支付户名" placeholder="请输入支付户名" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="银行卡号" prop="银行卡号">
                  <el-input v-model="formData.银行卡号" placeholder="请输入银行卡号" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开户行" prop="开户行">
                  <el-input v-model="formData.开户行" placeholder="请输入开户行" />
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 第11行：交房日期 + 是否开通燃气 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="交房日期" prop="交房日期">
                  <el-date-picker
                    v-model="formData.交房日期"
                    type="date"
                    placeholder="请选择交房日期"
                    value-format="timestamp"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否开通燃气" prop="是否开通燃气">
                  <el-select v-model="formData.是否开通燃气" placeholder="请选择" style="width:100%">
                    <el-option label="是" value="是" />
                    <el-option label="否" value="否" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确认</el-button>
    </span>

    <!-- 二次确认弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="confirmDialog.visible"
      width="420px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-warning" style="font-size: 48px; color: #e6a23c;" />
        <p style="margin-top: 16px; font-size: 16px; color: #303133;">
          请核实修改的信息，点击提交后不可撤回。
        </p>
      </div>
      <span slot="footer">
        <el-button @click="confirmDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmSubmit" :loading="submitting">确认</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'

export default {
  name: 'UpdateSfHouse',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },
  
  data() {
    const validateContractDate = (rule, value, callback) => {
      if (!value || !this.formData.合同起始日) {
        callback()
        return
      }
      if (value <= this.formData.合同起始日) {
        callback(new Error('合同到期日必须大于合同起始日'))
      } else {
        callback()
      }
    }
    
    return {
      dialogVisible: this.visible,
      submitting: false,
      
      // 修改前的数据（用于对比）
      updateDataBefore: {},
      
      // 表单数据
      formData: {
        产权证地址: '',
        不动产权号: '',
        丘权号: '',
        行政区: '',
         业务状态: '装修中',
        出房指导价: null,
        收房指导价: null,
        收房人: '',
        收房门店: '',
        房屋地址: '',
        室: null,
        厅: null,
        卫: null,
        '面积（平米）': null,
        楼层信息_第X层: null,
        楼层信息_共X层: null,
        用途: '住宅',
        朝向: '东',
        是否开通燃气: '是',
        水卡: '',
        电卡用户名: '',
        电卡: '',
        气卡: '',
        其他卡: '',
        '钥匙/密码': '',
        备注: '',
        房东姓名: '',
        房东电话: '',
        产权人身份证号: '',
        受托代理人姓名: '',
        委托人电话: '',
        送达地址: '',
         合同编号: '',
        收房渠道: '中介',
        收房费用: null,
        合同起始日: null,
        合同到期日: null,
        '第一年免租期（天）': null,
        '第二年免租期（天）': null,
        '第三年免租期（天）': null,
        免租期备注: '',
        押金: null,
        '收房租金（元/月）': null,
        支付周期: '按月',
        特别约定: '',
        支付户名: '',
        银行卡号: '',
        开户行: '',
        交房日期: null
      },
      
      formRules: {
        房屋地址: [
          { required: true, message: '请输入房屋地址', trigger: 'blur' }
        ],
        合同起始日: [
          { required: true, message: '请选择合同起始日', trigger: 'change' }
        ],
        合同到期日: [
          { required: true, message: '请选择合同到期日', trigger: 'change' },
          { validator: validateContractDate, trigger: 'change' }
        ],
        支付周期: [
          { required: true, message: '请选择支付周期', trigger: 'change' }
        ],
        '收房租金（元/月）': [
          { required: true, message: '请输入收房租金', trigger: 'blur' }
        ]
      },
      
      confirmDialog: {
        visible: false
      }
    }
  },
  
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initFormData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.resetForm()
      }
    }
  },
  
  methods: {
    // ====== 初始化表单数据 ======
   // ====== 初始化表单数据 ======
initFormData() {
  if (!this.rowData) return
  
  const data = this.rowData
  
  // 保存修改前的数据（深拷贝）
  this.updateDataBefore = JSON.parse(JSON.stringify(data))
  
  // 时间戳转毫秒级（el-date-picker 需要毫秒级）
  const toMilliseconds = (timestamp) => {
    if (!timestamp) return null
    // 如果是10位数（秒级），转为毫秒级
    if (String(timestamp).length === 10) {
      return timestamp * 1000
    }
    // 如果是13位数（毫秒级），直接返回
    return timestamp
  }
  
  // 填充表单
  this.formData = {
    产权证地址: data.产权证地址 || '',
    不动产权号: data.不动产权号 || '',
    丘权号: data.丘权号 || '',
    行政区: data.行政区 || '',
    业务状态: data.业务状态 || '装修中',
    出房指导价: data.出房指导价 !== undefined && data.出房指导价 !== null ? data.出房指导价 : null,
    收房指导价: data.收房指导价 !== undefined && data.收房指导价 !== null ? data.收房指导价 : null,
    收房人: data.收房人 || '',
    收房门店: data.收房门店 || '',
    房屋地址: data.房屋地址 || '',
    室: data.室 !== undefined && data.室 !== null ? data.室 : null,
    厅: data.厅 !== undefined && data.厅 !== null ? data.厅 : null,
    卫: data.卫 !== undefined && data.卫 !== null ? data.卫 : null,
    '面积（平米）': data['面积（平米）'] !== undefined && data['面积（平米）'] !== null ? data['面积（平米）'] : null,
    楼层信息_第X层: data['楼层信息（第X层）'] !== undefined && data['楼层信息（第X层）'] !== null ? data['楼层信息（第X层）'] : null,
    楼层信息_共X层: data['楼层信息（共X层）'] !== undefined && data['楼层信息（共X层）'] !== null ? data['楼层信息（共X层）'] : null,
    用途: data.用途 || '住宅',
    朝向: data.朝向 || '东',
    是否开通燃气: data.是否开通燃气 || '是',
    水卡: data.水卡 || '',
    电卡用户名: data.电卡用户名 || '',
    电卡: data.电卡 || '',
    气卡: data.气卡 || '',
    其他卡: data.其他卡 || '',
    '钥匙/密码': data['钥匙/密码'] || '',
    备注: data.备注 || '',
    房东姓名: data.房东姓名 || '',
    房东电话: data.房东电话 || '',
    产权人身份证号: data.产权人身份证号 || '',
    受托代理人姓名: data.受托代理人姓名 || '',
    委托人电话: data.委托人电话 || '',
    送达地址: data.送达地址 || '',
    合同编号: data.合同编号 || '',
    收房渠道: data.收房渠道 || '中介',
    收房费用: data.收房费用 !== undefined && data.收房费用 !== null ? data.收房费用 : null,
    // ====== 日期字段：秒级转毫秒级 ======
    合同起始日: toMilliseconds(data.合同起始日),
    合同到期日: toMilliseconds(data.合同到期日),
    交房日期: toMilliseconds(data.交房日期),
    '第一年免租期（天）': data['第一年免租期（天）'] !== undefined && data['第一年免租期（天）'] !== null ? data['第一年免租期（天）'] : null,
    '第二年免租期（天）': data['第二年免租期（天）'] !== undefined && data['第二年免租期（天）'] !== null ? data['第二年免租期（天）'] : null,
    '第三年免租期（天）': data['第三年免租期（天）'] !== undefined && data['第三年免租期（天）'] !== null ? data['第三年免租期（天）'] : null,
    免租期备注: data.免租期备注 || '',
    押金: data.押金 !== undefined && data.押金 !== null ? data.押金 : null,
    '收房租金（元/月）': data['收房租金（元/月）'] !== undefined && data['收房租金（元/月）'] !== null ? data['收房租金（元/月）'] : null,
    支付周期: data.支付周期 || '按月',
    特别约定: data.特别约定 || '',
    支付户名: data.支付户名 || '',
    银行卡号: data.银行卡号 || '',
    开户行: data.开户行 || ''
  }
  
  this.confirmDialog.visible = false
  this.$nextTick(() => {
    if (this.$refs.formRef) {
      this.$refs.formRef.clearValidate()
    }
  })
},
    
    // ====== 重置表单 ======
    resetForm() {
      this.formData = {
        产权证地址: '',
        不动产权号: '',
        丘权号: '',
        行政区: '',
        业务状态: '装修中',
        出房指导价: null,
        收房指导价: null,
        收房人: '',
        收房门店: '',
        房屋地址: '',
        室: null,
        厅: null,
        卫: null,
        '面积（平米）': null,
        楼层信息_第X层: null,
        楼层信息_共X层: null,
        用途: '住宅',
        朝向: '东',
        是否开通燃气: '是',
        水卡: '',
        电卡用户名: '',
        电卡: '',
        气卡: '',
        其他卡: '',
        '钥匙/密码': '',
        备注: '',
        房东姓名: '',
        房东电话: '',
        产权人身份证号: '',
        受托代理人姓名: '',
        委托人电话: '',
        送达地址: '',
         合同编号: '',
        收房渠道: '中介',
        收房费用: null,
        合同起始日: null,
        合同到期日: null,
        '第一年免租期（天）': null,
        '第二年免租期（天）': null,
        '第三年免租期（天）': null,
        免租期备注: '',
        押金: null,
        '收房租金（元/月）': null,
        支付周期: '按月',
        特别约定: '',
        支付户名: '',
        银行卡号: '',
        开户行: '',
        交房日期: null
      }
      this.updateDataBefore = {}
      this.confirmDialog.visible = false
      this.submitting = false
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    
    // ====== 取消 ======
    handleCancel() {
      // 检查是否有内容被修改
      const hasChanges = this.checkHasChanges()
      
      if (hasChanges) {
        this.$confirm('确定要取消吗？已修改的数据将丢失。', '提示', {
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => {})
      } else {
        this.dialogVisible = false
      }
    },
    
    // ====== 检查是否有修改 ======
    checkHasChanges() {
      const currentData = { ...this.formData }
      const beforeData = this.updateDataBefore
      
      // 对比当前数据和修改前数据
      for (const key in currentData) {
        if (currentData[key] !== beforeData[key]) {
          return true
        }
      }
      return false
    },
    
    handleClose() {
      this.dialogVisible = false
    },
    
    // ====== 提交（第一步：二次确认弹窗） ======
    handleSubmit() {
      // 先做表单验证
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.$message.warning('请完善表单信息')
          return
        }
        // 检查是否有修改
        if (!this.checkHasChanges()) {
          this.$message.warning('未检测到任何修改')
          return
        }
        // 验证通过，弹出二次确认
        this.confirmDialog.visible = true
      })
    },
    
    // ====== 确认提交（第二步：实际提交） ======
    handleConfirmSubmit() {
      this.submitting = true
      
      const submitData = this.buildSubmitData()
      console.log('修改提交数据===', submitData)
      
      sqlBaseApi.update(submitData).then((res) => {
        console.log('修改返回===', res)
        
        if (res.code === 200) {
          this.$message.success('修改成功！')
          this.confirmDialog.visible = false
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.message || '修改失败')
        }
      }).catch((err) => {
        console.error('修改请求失败===', err)
        this.$message.error(err.message || '修改失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
    },
    
    // ====== 构建提交数据（只包含修改的字段） ======
    buildSubmitData() {
      const currentData = { ...this.formData }
      const beforeData = this.updateDataBefore
      const updateData = {}
      
      // 遍历当前数据，只保留修改过的字段
      for (const key in currentData) {
        // 跳过 id（如果有）
        if (key === 'id') continue
        
        // 检查是否有变化
        if (currentData[key] !== beforeData[key]) {
          updateData[key] = currentData[key]
        }
      }
      
      // 处理楼层信息：将两个字段合并处理
      // 前端字段名 -> 后端字段名
      // 楼层信息_第X层 -> 楼层信息（第X层）
      // 楼层信息_共X层 -> 楼层信息（共X层）
      const floorX = updateData.楼层信息_第X层
      const floorTotal = updateData.楼层信息_共X层
      
      // 删除前端临时字段
      delete updateData.楼层信息_第X层
      delete updateData.楼层信息_共X层
      
      // 添加后端需要的字段（仅当有值时）
      if (floorX !== null && floorX !== undefined && floorX !== '') {
        updateData['楼层信息（第X层）'] = floorX
      }
      if (floorTotal !== null && floorTotal !== undefined && floorTotal !== '') {
        updateData['楼层信息（共X层）'] = floorTotal
      }
      
      // 处理日期：时间戳转为秒（后端需要秒级时间戳）
      if (updateData.合同起始日) {
        updateData.合同起始日 = Math.floor(updateData.合同起始日 / 1000)
      }
      if (updateData.合同到期日) {
        updateData.合同到期日 = Math.floor(updateData.合同到期日 / 1000)
      }
      if (updateData.交房日期) {
        updateData.交房日期 = Math.floor(updateData.交房日期 / 1000)
      }
      
      // 移除空值字段
      Object.keys(updateData).forEach(key => {
        if (updateData[key] === null || updateData[key] === undefined || updateData[key] === '') {
          delete updateData[key]
        }
      })
      
      return {
        tableName: '房源',
        data: updateData,
        where: {
          id: this.rowData?.id
        }
      }
    }
  }
}
</script>

<style scoped>
.update-house-dialog /deep/ .el-dialog {
  max-height: 94vh;
  display: flex;
  flex-direction: column;
}

.update-house-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.update-house-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

/* ====== 滚动区域（原生滚动） ====== */
.dialog-content-wrapper {
  height: 68vh;
  overflow: hidden;
  position: relative;
}

.scroll-area-native {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

/* ====== 自定义滚动条样式 ====== */
.scroll-area-native::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.scroll-area-native::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.scroll-area-native::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.scroll-area-native::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

/* Firefox 滚动条 */
.scroll-area-native {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

/* ====== 表单分组 ====== */
.form-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding: 10px 0;
  margin-bottom: 16px;
  border-bottom: 2px solid #409EFF;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background: #409EFF;
}

.update-form /deep/ .el-form-item {
  margin-bottom: 18px;
}

.update-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 12px;
  white-space: nowrap;
}

.update-form /deep/ .el-input-number {
  width: 100%;
}

.update-form /deep/ .el-input-number .el-input__inner {
  text-align: left;
}

.update-form /deep/ .el-select {
  width: 100%;
}

.update-form /deep/ .el-date-editor {
  width: 100%;
}

.update-form /deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  color: #909399;
}

.el-icon-warning {
  color: #e6a23c;
}

@media (max-width: 768px) {
  .update-house-dialog /deep/ .el-dialog {
    width: 95% !important;
  }
  
  .dialog-content-wrapper {
    height: 50vh;
  }
}
</style>